import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=61c4e768&scoped=true&"
import script from "./OrgProfile.vue?vue&type=script&lang=js&"
export * from "./OrgProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4e768",
  null
  
)

export default component.exports